import React from 'react';
import { ContentWrapper } from './styled';
import MetricLensContent from './MetricLensContent';
import useBaseExport from './MetricLensTable/hooks/useBaseExport';
import { useManageTs } from './MetricLensTable/hooks/useTimeseries';

function Content() {

  useManageTs();
  useBaseExport();

  return (
    <ContentWrapper>
      <MetricLensContent />
    </ContentWrapper>
  );
}

export default Content;
